import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../common/models/Visiable";
import { AllState } from "../models/AllState";

const setFonVisiable = (state: AllState, action: PayloadAction<Visiable>) => {
    state.isFonVisiable = action.payload.visiable;
}

export default setFonVisiable;